import apiUrlConfig from "configs/apiUrlConfig";
import UnAuthenticatedRequest from 'services/requests/UnAuthenticated';

const URLS = {
  VALIDATE: `${apiUrlConfig.apiEndPoint()}/user_survey_rewards/validate_redeemed_reward`,
  VERIFY_LOCATION: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/verify_location_code`
};

function insertBusinessIdToUrl(url, id) {
  return url.replace(':business_id', id);
}

class UserSurveyRewardApi {
  /**
   * API to validate the token
   * @param {object} data
   */
  static validateToken(data) {
    const VALIDATE_REWARD = `${URLS.VALIDATE}?${data}`;

    return UnAuthenticatedRequest.get(VALIDATE_REWARD);
  }

  static validateLocationCode(businessId, data) {
    const VERIFY_LOCATION = insertBusinessIdToUrl(URLS.VERIFY_LOCATION, businessId);
    const VERIFY_LOCATION_URL = `${VERIFY_LOCATION}?${data}`;

    return UnAuthenticatedRequest.get(VERIFY_LOCATION_URL);
  }
}

export default UserSurveyRewardApi;



// WEBPACK FOOTER //
// ./src/apis/UserSurveyReward.js